export default __webpack_public_path__ + "static/media/violin1.7143666a.png";